import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Produit } from 'app/models/produit';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { ProduitsService } from 'app/services/produits/produits.service';
import { AwscontrolService, UploadResponse } from 'app/services/aws/awscontrol.service';
import { FormControl, Validators } from '@angular/forms';
import Swal from "sweetalert2";
import { HttpErrorResponse } from "@angular/common/http";
import { Location } from '@angular/common';

@Component({
  selector: 'app-ajouter-produit',
  templateUrl: './ajouter-produit.component.html',
  styleUrls: ['./ajouter-produit.component.scss']
})
export class AjouterProduitComponent implements OnInit {

  produit: Produit = new Produit();
  
  // Form Controls
  numCommercialFormControl: FormControl;
  emailCommercialFormControl: FormControl;
  
  // File handling
  selectedFiles: FileList;
  fileNames: any[] = [];
  
  // Images
  public image: string = '';
  public imagePromo: string = '';
  allAttch: any[] = [];
  
  // Data
  public materiaux: any;
  agenciesApp: any;
  idAgency: any;
  NameAgence: any;
  
  // Error messages
  nameErrorMessage: string = '';
  statusErrorMessage: string = '';
  nomCommercialErrorMessage: string = '';
  
  // Loading state
  isUploading: boolean = false;
  isUploadingMain: boolean = false;
  isUploadingPromo: boolean = false;
  isSubmitting: boolean = false;

  constructor(
    private router: Router,
    private agenciesService: AgenciesService,
    private produitService: ProduitsService,
    private awsService: AwscontrolService, // Add AWS service
    private location: Location
  ) {
    this.numCommercialFormControl = new FormControl('', [
      Validators.pattern('^[0-9]{8}$')
    ]);
    
    this.emailCommercialFormControl = new FormControl('', [
      Validators.email
    ]);
  }

  ngOnInit(): void {
    this.getData();
    this.idAgency = this.agenciesService.getIdAgency();
    if (this.idAgency) {
      this.AgencyNameById();
    }
  }

  getData(): void {
    this.getAllAgencies();
    this.agenciesService.getList().subscribe((data) => {
      this.materiaux = data;
    });
  }

  getAllAgencies(): void {
    this.agenciesService.getList().subscribe((data) => {
      this.agenciesApp = data;
    });
  }

  AgencyNameById(): void {
    this.agenciesService.getAgencieById(this.idAgency).subscribe((data: any) => {
      this.NameAgence = data.name;
    });
  }

  // Image upload handlers
  selectFileimg(e: any): void {
    this.selectedFiles = e.target.files;
    this.uploadimg();
  }

  uploadimg(): void {
    if (!this.selectedFiles || this.selectedFiles.length === 0) return;
    
    this.isUploading = true;
    this.isUploadingMain = true;
    
    for (let i = 0; i < this.selectedFiles.length; i++) {
      const file = this.selectedFiles[i];
      this.uploadFileimg(file);
    }
  }

  async uploadFileimg(file: any): Promise<void> {
    this.fileNames.push(file.name);
    
    try {
      // Use AWS service to upload file
      const folder = 'produits';
      const response = await this.awsService.uploadFile(file, folder).toPromise();
      
      if (response.success && response.urls && response.urls.length > 0) {
        const uploadedUrl = response.urls[0];
        localStorage.setItem('prodImg', JSON.stringify(uploadedUrl));
        this.allAttch.push(uploadedUrl);
        this.image = uploadedUrl;
      } else {
        Swal.fire({
          icon: "error",
          title: "Erreur",
          text: response.error || "Échec du téléchargement de l'image",
        });
      }
    } catch (error: any) {
      console.error('Upload error:', error);
      Swal.fire({
        icon: "error",
        title: "Erreur",
        text: "Erreur lors du téléchargement de l'image",
      });
    } finally {
      this.isUploading = false;
      this.isUploadingMain = false;
    }
  }

  // Promo image upload handlers
  selectFileimgPromo(e: any): void {
    this.selectedFiles = e.target.files;
    this.uploadimgPromo();
  }

  uploadimgPromo(): void {
    if (!this.selectedFiles || this.selectedFiles.length === 0) return;
    
    this.isUploading = true;
    this.isUploadingPromo = true;
    
    for (let i = 0; i < this.selectedFiles.length; i++) {
      const file = this.selectedFiles[i];
      this.uploadFileimgPromo(file);
    }
  }

  async uploadFileimgPromo(file: any): Promise<void> {
    this.fileNames.push(file.name);
    
    try {
      // Use AWS service to upload file
      const folder = 'produits-promo';
      const response = await this.awsService.uploadFile(file, folder).toPromise();
      
      if (response.success && response.urls && response.urls.length > 0) {
        const uploadedUrl = response.urls[0];
        localStorage.setItem('promoImg', JSON.stringify(uploadedUrl));
        this.allAttch.push(uploadedUrl);
        this.imagePromo = uploadedUrl;
      } else {
        Swal.fire({
          icon: "error",
          title: "Erreur",
          text: response.error || "Échec du téléchargement de l'image promotionnelle",
        });
      }
    } catch (error: any) {
      console.error('Upload error:', error);
      Swal.fire({
        icon: "error",
        title: "Erreur",
        text: "Erreur lors du téléchargement de l'image promotionnelle",
      });
    } finally {
      this.isUploading = false;
      this.isUploadingPromo = false;
    }
  }

  // Validation methods
  validateForm(): boolean {
    let isValid = true;

    // Validate name
    if (!this.produit.name || this.produit.name.trim() === '') {
      this.nameErrorMessage = 'Le nom est requis';
      isValid = false;
    } else {
      this.nameErrorMessage = '';
    }

    // Validate status
    if (!this.produit.status || this.produit.status.trim() === '') {
      this.statusErrorMessage = 'Le status est requis';
      isValid = false;
    } else {
      this.statusErrorMessage = '';
    }

    // Validate commercial name
    if (!this.produit.nomCommercial || this.produit.nomCommercial.trim() === '') {
      this.nomCommercialErrorMessage = 'Le nom commercial est requis';
      isValid = false;
    } else {
      this.nomCommercialErrorMessage = '';
    }

    return isValid;
  }

  validateVideoUrl(): boolean {
    if (!this.produit.videoUrlProduit) return true; // Optional field
    const youtubeUrlPattern = /^(https?\:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/;
    return youtubeUrlPattern.test(this.produit.videoUrlProduit);
  }

  // Submit handler
  onSubmit(): void {
    // Check if uploads are in progress
    if (this.isUploadingMain || this.isUploadingPromo || this.isUploading) {
      Swal.fire({
        icon: "warning",
        title: "Téléchargement en cours",
        text: "Veuillez attendre la fin du téléchargement des images",
      });
      return;
    }

    if (!this.validateForm()) {
      Swal.fire({
        icon: "error",
        title: "Erreur de validation",
        text: "Veuillez remplir tous les champs obligatoires correctement",
      });
      return;
    }

    if (this.numCommercialFormControl.invalid) {
      Swal.fire({
        icon: "error",
        title: "Erreur",
        text: "Le numéro de commercial doit contenir exactement 8 chiffres",
      });
      return;
    }

    if (this.emailCommercialFormControl.invalid && this.produit.emailCommercial) {
      Swal.fire({
        icon: "error",
        title: "Erreur",
        text: "Veuillez entrer une adresse email valide",
      });
      return;
    }

    this.isSubmitting = true;

    const produits = {
      name: this.produit.name,
      status: this.produit.status,
      description: this.produit.description,
      prix: this.produit.prix,
      agencyName: this.NameAgence,
      categoryList: this.produit.categoryList,
      imageUrl: this.image || JSON.parse(String(localStorage.getItem("prodImg"))),
      promoTitle: this.produit.promoTitle,
      videoUrlProduit: this.produit.videoUrlProduit,
      nomCommercial: this.produit.nomCommercial,
      numCommercial: this.numCommercialFormControl.value,
      emailCommercial: this.emailCommercialFormControl.value,
      promoImg: this.imagePromo || JSON.parse(String(localStorage.getItem("promoImg")))
    };

    this.produitService.createProduit(produits).subscribe(
      () => {
        this.isSubmitting = false;
        Swal.fire({
          icon: "success",
          title: "Succès",
          text: "Produit créé avec succès",
          timer: 2000
        });
        
        setTimeout(() => {
          this.getData();
          this.navigateBack();
        }, 500);
      },
      (error: HttpErrorResponse) => {
        this.isSubmitting = false;
        console.error("Error:", error);
        
        Swal.fire({
          icon: "error",
          title: "Erreur",
          text: "Une erreur s'est produite lors de la création du produit. Veuillez vérifier tous les champs.",
        });
      }
    );
  }

  navigateBack(): void {
    this.location.back();
  }
}